import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook, Dumbbell } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-column">
            <div className="footer-brand">
              <Dumbbell size={32} />
              <h3 className="heading-3">James Farina Personal Training</h3>
            </div>
            <p className="body-small">
              Transform your fitness with personalized training programs designed 
              for busy professionals in New Westminster and Burnaby.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/about" className="footer-link">About James</Link></li>
              <li><Link to="/services" className="footer-link">Services</Link></li>
              <li><Link to="/results" className="footer-link">Results</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-column">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><span className="footer-link-text">Strength & Conditioning</span></li>
              <li><span className="footer-link-text">Weight Loss Programs</span></li>
              <li><span className="footer-link-text">Bodybuilding Prep</span></li>
              <li><span className="footer-link-text">Marathon Training</span></li>
              <li><span className="footer-link-text">Lifestyle Coaching</span></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-column">
            <h4 className="footer-heading">Get In Touch</h4>
            <ul className="footer-contact">
              <li className="footer-contact-item">
                <Phone size={18} />
                <a href="tel:7787886448" className="footer-link">778-788-6448</a>
              </li>
              <li className="footer-contact-item">
                <Mail size={18} />
                <a href="mailto:jamesfarina18@gmail.com" className="footer-link">jamesfarina18@gmail.com</a>
              </li>
              <li className="footer-contact-item">
                <MapPin size={18} />
                <span className="footer-link-text">New Westminster & Burnaby, BC</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="caption">
            &copy; {currentYear} James Farina Personal Training. All rights reserved.
          </p>
          <p className="caption">
            Helping you achieve your fitness goals since day one.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
